module.exports = __webpack_public_path__ + "media/entities/1601-62d35c3c.png";